import { createContext, useEffect, useState } from 'react';
import api, { setApiContext } from 'services/api';
import axios from 'axios';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(true);
  const [postLoading, setPostLoading] = useState(false);
  const isAuthenticated = !!user;

  useEffect(() => {
    refresh();
  }, []);

  const saveUser = async (user) => {
    try {
      localStorage.setItem('ESolution:refreshToken', user?.refresh_token);
      api.defaults.headers.common[
        'Authorization'
      ] = `Bearer ${user?.access_token}`;
      const { data } = await api.get('/Auth/User', { skipRetry: true });
      setUser({ ...user, ...data });
    } catch (error) {
      throw error;
    } finally {
      setIsRefreshing(false);
    }
  };

  const login = async (body) => {
    try {
      setLoading(true);
      const url = process.env.REACT_APP_API_AUTH_URL + '/SignIn';
      const { data } = await axios.post(url, body);
      await saveUser(data);
    } catch (error) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  const refresh = async () => {
    try {
      setIsRefreshing(true);
      const refresh_token = localStorage.getItem('ESolution:refreshToken');
      const url = process.env.REACT_APP_API_AUTH_URL + '/Refresh';
      const body = { refresh_token };
      const { data } = await axios.post(url, body);
      await saveUser(data);
    } catch (error) {
      setUser(null);
    } finally {
      setIsRefreshing(false);
    }
  };

  const logout = async () => {
    try {
      const url = process.env.REACT_APP_API_AUTH_URL + '/SignOut';
      const options = { withCredentials: true };
      await axios.post(url, null, options);
    } catch (error) {
    } finally {
      localStorage.removeItem('ESolution:refreshToken');
      api.defaults.headers.common['Authorization'] = null;
      setUser(null);
    }
  };

  const postUser = async ({ data, cb }) => {
    try {
      setPostLoading(true);
      await api.post('/Auth/User', data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  setApiContext({ refresh, logout });

  return (
    <AuthContext.Provider
      value={{
        user,
        login,
        logout,
        loading,
        postUser,
        postLoading,
        isRefreshing,
        isAuthenticated,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
